:host{display:flex;align-items:center;justify-content:space-between;border-right:2px solid rgba(35,36,38,.12)}.right-toolbar{display:flex}
/*# sourceMappingURL=cv-toolbar.component.css.map */
